import Helper from '../../../utils/helper';
import { ReturnCommand } from '../../../services/command';
import CargoManagementCommand from '../../../services/command/cargoManagement/CargoManagementCommand.services';

export const buildReturnStatusUpdateRequest = (item: any) => ({
    storeCode: Helper.getStoreCode(),
    returnId: Number(item.iadeId),
    status: 16,
    customerId: item.musterId,
});

export const updateReturnStatuses = async (rows: any[], onFailure: () => void) => {
    await Promise.all(
        rows.map(async (item) => {
            const res = await ReturnCommand.UpdateReturnStatus(buildReturnStatusUpdateRequest(item));
            if (!res.result) {
                onFailure();
            }
        })
    );
};

export const sendReturnRejectDeliveryList = async (
    base64String: string | ArrayBuffer | null,
    selectedCargo: number,
    subject: string
) => {
    await CargoManagementCommand.SendDeliveryList({
        Document: base64String,
        ShippingCompanyId: selectedCargo,
        Subject: subject,
        FileName: 'ReturnRejectListTest',
    });
};

export const readBlobAsDataUrl = (blob: Blob): Promise<string | ArrayBuffer | null> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(blob);
    });
